import { useContext, useState } from 'react';
import HastaPublicaNovaArrematacao from './hastaPublicaNovaAquisicao/hastaPublicaNovaArrematacao';
import HastaPublicaListaProcessos from './hastaPublicaListaProcessos/hastaPublicaListaProcessos';
import { useBackEndRequests } from '../../lib/backEndRequests';
import { DiefCfemContext } from '../../../../contexts/DiefCfemContext';
import { IArrematacao } from '../../../../interfaces/IArrematacao';
import { useNotificacao } from '../../../../hooks/useNotificacao';

interface IHastaPublicaNovaAquisicaoProps {
  isNovaArrematacao: boolean;
  setNovaArrematacao: React.Dispatch<React.SetStateAction<boolean>>;
}

function HastaPublicaProcessoMinerario({ isNovaArrematacao, setNovaArrematacao }: IHastaPublicaNovaAquisicaoProps) {
  const [edicaoArrematacao, setEdicaoArrematacao] = useState<IArrematacao>();

  const { postSalvarRascunhoDeclaracao } = useBackEndRequests();

  const context = useContext(DiefCfemContext);
  const declaracaoHastaPublica = context?.declaracaoHastaPublica;

  const mostrarNotificacao = useNotificacao();

  const salvarRascunho = async () => {
    if (declaracaoHastaPublica)
      await postSalvarRascunhoDeclaracao(declaracaoHastaPublica).catch((err) =>
        mostrarNotificacao({
          tipo: 'danger',
          conteudo: 'Erro ao salvar rascunho',
          ...(err && { complementoSentryId: err }),
        })
      );
    else
      mostrarNotificacao({
        tipo: 'danger',
        conteudo: 'Erro ao salvar rascunho',
      });
  };

  return (
    <>
      {isNovaArrematacao ? (
        <HastaPublicaNovaArrematacao
          setNovaArrematacao={setNovaArrematacao}
          edicaoArrematacao={edicaoArrematacao}
          setEdicaoArrematacao={setEdicaoArrematacao}
          salvarRascunho={salvarRascunho}
        />
      ) : (
        <HastaPublicaListaProcessos
          setNovaArrematacao={setNovaArrematacao}
          setEdicaoArrematacao={setEdicaoArrematacao}
        />
      )}
    </>
  );
}

export default HastaPublicaProcessoMinerario;
